import React from 'react';
import {Helmet} from "react-helmet";
import '../index.css';
import { NavLink } from 'react-router-dom';

const ChildSafetyPolicy = () => {
return (
	<div  className="blurBg"
	style={{ 	display: 'flex',
    flexDirection: 'column',
		justifyContent: 'Left',
		alignItems: 'Left', 
    color : '#ffffff',
	}
}
	> 
  
  <Helmet>
        <meta charSet="utf-8" />
        <title>Youtubers Clan- Child Safety Policy</title>     
				<meta name="description" content="Youtubers Clan App has certain privacy policies regarding enforces strict child safety measures, prohibits exploitation, and provides clear reporting tools to protect users and ensure a safe online environment." />
				<meta name="keywords" content=", Child Safety Policy, Youtubers, YoutubersClan, Privacy Policy, Youtubers Clan, Home, Youtuber Clan App, YT Clan" />
				<meta name="author" content="Megamind Core"/>
  </Helmet>

  <div className="privacyPolicyText">
    <br/>  
    <br/>
  </div>
  <div className="privacyPolicyHeading">Child Safety & Abuse Prevention Policy</div>
  <div className="privacyPolicyText">
    At YouTubers Clan App, we have a strict zero‑tolerance policy toward child sexual abuse and exploitation (CSAE). We explicitly prohibit any form of child sexual abuse material (CSAM), grooming, exploitation, or predatory behavior.
  </div>  
  <div className="privacyPolicySubHeading">
    Reporting Mechanism
  </div> 
  <div className="privacyPolicyText">
    Please refer to the following methods to report Child Safety:
  <ul>
    <li>Report an issue via our in‑app feature (Side Navigation → Contact Us → Email)</li> 
    <li>Report a particular user via our in‑app feature (User Profile → Overflow Menu at top-right corner → Report → Email) </li>
    <li>Directly contact us at <b>
          <NavLink
                to='#'
                onClick={(e) => {
                    window.location.href = "mailto:support@youtubersclan.com";
                    e.preventDefault();
                }}
            >
            support@youtubersclan.com
          </NavLink></b>
    </li>
  </ul> 
  </div>  
  <div className="privacyPolicySubHeading">
    Enforcement
  </div>  
  <div className="privacyPolicyText">
  Our Trust & Safety team reviews all reports immediately. Any content that violates our policies is removed without delay, and accounts engaging in prohibited behavior may be suspended or permanently banned.
  We fully cooperate with law enforcement and relevant authorities to ensure a safe environment for all users.
  </div>
  <div className="privacyPolicySubHeading">
    Age Policy
  </div>  
  <div className="privacyPolicyText">
  Our services are intended for users 18 and older. 
  We do not knowingly allow minors to use our service, and any personal information collected from them is deleted immediately. 
  Users can only set their age as 18 or above when updating their profile.
  </div>  
  <div className="privacyPolicySubHeading">
  Legal & Policy Compliance
  </div>   
  <div className="privacyPolicyText">
  We comply with applicable child-protection laws and Google Play’s Child Safety Standards.  For details, see Google’s official policy at <b> 
    <a href="https://support.google.com/googleplay/android-developer/answer/9878809" target="_blank" rel="noopener noreferrer"> Google Play Child Safety Standards</a> 
    </b>
  </div>    
  <div className="privacyPolicySubHeading"> 
    Changes to This Privacy Policy
  </div>   
  <div className="privacyPolicyText"> 
    This policy is reviewed regularly and updated to align with current legal standards and best practices for child protection.
  </div>    
  <div className="privacyPolicySubHeading">
    Contact Us
  </div>   
  <div className="privacyPolicyText"> 
    If you have any questions or suggestions about my
    Privacy Policy, do not hesitate to contact us at <b>
      <NavLink
            to='#'
            onClick={(e) => {
                window.location.href = "mailto:support@youtubersclan.com";
                e.preventDefault();
            }}
        >
        support@youtubersclan.com
      </NavLink></b>
  </div>   
  
  <div className="privacyPolicyText">
    <br/>  
    <br/>
  </div>
	</div>
);
};

export default ChildSafetyPolicy;
